define('modules/pagination/pagination_view',[
  'backbone',
  'jquery',
  '_',


  './pagination_model',
  './pagination_item_collection',

  'text!./pagination_template.html',
  'text!./pagination_item_template.html'

], function (Backbone, $, _,
             PaginationModel,
             PaginationItemCollection,
             PaginationTemplate,
             PaginationItemTemplate) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (listCollection, options) {

      _.extend(this, listCollection.params);
      this.subViews = [];

      this.useEventTriggerToInvokeRefresh = options && options.useEventTriggerToInvokeRefresh;

      this.model = new PaginationModel({
        offset: parseInt(this.offset, 10),
        limit: parseInt(this.limit, 10),
        originalLimit: parseInt(this.limit, 10),
        total: parseInt(this.total, 10),
        pages: Math.ceil(parseInt(this.total, 10) / parseInt(this.limit, 10))
      });

      this.listenTo(this.model, 'change', function (model) {
        this.listCollection.params = _.extend(this.listCollection.params, {
          offset: model.get('offset'),
          limit: model.get('limit')
        });

        if (this.useEventTriggerToInvokeRefresh) {
          Backbone.trigger('pagination:fetch');
        } else {
          listCollection.fetch();
        }
      }, this);

      this.listCollection = listCollection;
      this.collection = new PaginationItemCollection();

      this.listenTo(this.collection, 'reset', function () {

        this.renderItems();

      }, this);

      if (this.limit) {
        this.render();
        this.parseItems();
      }

    },

    template: _.template(PaginationTemplate),
    item_template: _.template(PaginationItemTemplate),

    events: {
      'click .js-view-all': 'viewAll',
      'click .list-navigation-pagination a:not(.truncated)': 'changeOffset'
    },

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    parseItems: function () {
      var i, pages, items = [],
          truncate = false, truncated = [], visible = [];

      pages = this.model.get('pages');

      if (pages > 5) {
        // show first, last and current +-1 in pagination
        truncate = true;
        visible.push(
            0,
            this.model.get('offset') - this.model.get('limit'),
            this.model.get('offset'),
            this.model.get('offset') + this.model.get('limit'),
            (pages - 1) * this.model.get('limit')
        );
        //truncate current +- 2
        truncated.push(
            this.model.get('offset') - (this.model.get('limit') * 2),
            this.model.get('offset') + (this.model.get('limit') * 2)
        );
      }

      for (i = 0; i < pages; i += 1) {
        var offset = i * this.model.get('limit');
        items.push({
          id: i,
          label: i + 1,
          offset: offset,
          active: offset === this.model.get('offset'),
          truncate: truncate,
          visible: truncate && _.indexOf(visible, offset) !== -1,
          truncated: truncate && _.indexOf(truncated, offset) !== -1
        });
      }
      this.collection.reset(items);
    },

    viewAll: function (e) {
      e.preventDefault();

      this.model.set({
        offset: 0,
        limit: 999,
        pages: 1
      });
    },

    changeOffset: function (e) {
      e.preventDefault();

      var offset = parseInt($(e.currentTarget).attr('data-offset'), 10);
      var direction = $(e.currentTarget).attr('data-direction');
      var currentId = parseInt(this.$('.active').attr('data-id'), 10);
      var itemId;
      var newOffset;

      if (direction === 'previous') {
        itemId = currentId - 1 >= 0 ? currentId - 1 : 0;
        newOffset = itemId * this.model.get('limit');
      } else if (direction === 'next') {
        itemId = currentId + 1 < this.model.get('pages') ? currentId + 1 : currentId;
        newOffset = itemId * this.model.get('limit');
      } else {
        newOffset = offset ? offset : 0;
        itemId = parseInt($(e.currentTarget).attr('data-id'), 10);
      }
      
      if (newOffset !== this.model.get('offset')) {
        this.model.set({
              offset: newOffset,
              limit: this.model.get('originalLimit')
            }
        );

        this.$('.active').removeClass('active');
        this.$('a[data-id=' + itemId + ']').addClass('active');
      }
    },

    renderItems: function () {
      var items = [];

      if (this.model.get('pages') < 2) {
        this.$el.attr('class', 'show-all');
      } else {
        this.$el.attr('class', 'show-pagination');
      }

      this.collection.each(function (model) {
        items.push(this.item_template(model.toJSON()));
      }, this);

      this.$('.js-pagination-items').html(items);
    },

    remove: function () {
      this.model.off(null, null, this);
      this.collection = false;

      this.$el.off();
      this._removeElement();
      this.stopListening();
      return this;
    }

  });
  return View;
});

